/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class VIPRLibraries
 * @classdesc
 */
define([
	'text!./viprVisLibrary.json',
	'com/ibm/vida/control/vida'
], (viprVisLibrary, vida) => {

	class VIPRLibraries  {
		constructor(options) {
			this.dashboardApi = options.dashboardApi;
		}

		setVIPRLibraries() {
			const libraries = JSON.parse(viprVisLibrary);

			const featureChecker = this.dashboardApi.getGlassCoreSvc('.FeatureChecker');
			const userCapabilities = this.dashboardApi.getGlassCoreSvc('.UserProfile').capabilities;
			let hasPermission =  userCapabilities.indexOf('canDevelopVisualizations') !== -1 || featureChecker.checkValue('dashboard', 'canDevelopVisualizations', 'enabled');
			if (hasPermission) {
				const extendedVisPreview = libraries['custom'][0];
				extendedVisPreview.isCustomVis = true;
				const extendedSchematicPreview = libraries['custom'][1];
				extendedSchematicPreview.isSchematic = true;
				extendedVisPreview.location = vida.sdk.bundleLocation;
			} else {
				libraries['custom'].length = 0;
			}
			return libraries;
		}

		static isSystemLib (libId, systemLibs = []) {
			const systemVis = systemLibs.find(lib => {
				return lib === libId;
			}) || null;

			return systemVis ? true : false;
		}
	}

	VIPRLibraries.LIB_TYPE_ALL = 'all_libs';
	VIPRLibraries.LIB_TYPE_SYSTEM = 'system_libs';
	VIPRLibraries.LIB_TYPE_CUSTOM = 'custom_libs';
	VIPRLibraries.LOAD_DEFINITION_ERROR = 'loadDefinitionError';

	return VIPRLibraries;
});
